import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import {MakeModel} from '../../../../../../model/make.model';

@Component({
    selector: 'app-shared-offer-set-rules-filter',
    templateUrl: './shared-offer-set-rules-filter.component.html',
    styleUrls: ['./shared-offer-set-rules-filter.component.scss'],
    standalone: false
})
export class SharedOfferSetRulesFilterComponent implements OnInit {
  @Input() ruleForm!: FormGroup;
  @Input() controlName!: string;
  @Input() label!: string;
  @Input() propertyValueFilters: any[] = [];
  @Input() makes: MakeModel[] = [];
  @Input() sourceAccountOptions: any[] = [];
  @Input() panelIndex!: number;

  filterOperators = [
    { label: 'Equals', value: 'equal to', filterType: 'number' },
    { label: 'Greater Than or Equal', value: 'greater than or equal to', filterType: 'number' },
    { label: 'Less Than or Equal', value: 'less than or equal to', filterType: 'number' },
    { label: 'Greater Than', value: 'greater than', filterType: 'number' },
    { label: 'Less Than', value: 'less than', filterType: 'number' },
    { label: 'Not Equal', value: 'not equal to', filterType: 'number' },
    { label: 'Contains', value: 'contains', filterType: 'string' },
    { label: 'Begins With', value: 'begins with', filterType: 'string' },
    { label: 'In', value: 'in', filterType: 'string' },
    { label: 'Is', value: 'is', filterType: 'string' },
    { label: 'Like', value: 'like', filterType: 'string' },
    { label: 'Is Not', value: 'is not', filterType: 'string' },
    { label: 'Not Contains', value: 'not contains', filterType: 'string' },
    { label: 'Not In', value: 'not in', filterType: 'string' },
    { label: 'Not Like', value: 'not like', filterType: 'string' },
  ];

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    if (!this.ruleForm.get(this.controlName)) {
      this.ruleForm.addControl(this.controlName, this.formBuilder.array([]));
    }
  }

  /**
   * Get the FormArray of rules from the parent FormGroup
   */
  get rules(): FormArray {
    return this.ruleForm.get(this.controlName) as FormArray;
  }

  /**
   * Add a new rule Filter to the FormArray
   */
  addRule() {
    const ruleGroup = this.formBuilder.group({
      propertyValue: [''],
      selectedOperator: [''],
      value: ['']
    });

    this.rules.push(ruleGroup);
  }

  /**
   * Delete a rule Filter from the FormArray
   * @param index
   */
  deleteRule(index: number) {
    if (this.rules.length > index) {
      this.rules.removeAt(index);
      this.ruleForm.markAsDirty();
    }
  }

  /**
   * Get the available operator options based on the selected property type
   */
  getOperatorOptions(propertyId: string) {
    let result = this.filterOperators;
    const property = this.propertyValueFilters.find((property) => property.value === propertyId);
    if (property) {
      if (property.label === 'Make') {
        result = this.filterOperators.filter((operator) => operator.label === 'In' || operator.label === 'Is');
      } else if (property.label === 'Account ID' || property.label === 'MPOP Account') {
        result = this.filterOperators.filter((operator) => operator.label === 'In' || operator.label === 'Not In');
      } else if (property.type === 'number') {
        result = this.filterOperators.filter((operator) => operator.filterType === 'number');
      } else if (property.type === 'string') {
        result = this.filterOperators.filter((operator) => operator.filterType === 'string');
      }
    }
    return result;
  }

  /**
   * Check if a user has selected a specific filter
   */
  isFilterSelected(rule: AbstractControl, filterName: string): boolean {
    let result = false;
    const propertyId = rule.get('propertyValue')?.value;
    const property = this.propertyValueFilters.find((property) => property.value === propertyId);

    if (property && property.label === filterName) {
      result = true;
    }

    return result;
  }

  /**
   * Check if a user has selected the Account Id filter
   */
  isAccountIdFilterSelected(rule: AbstractControl): boolean {
    let result = false;
    const propertyId = rule.get('propertyValue')?.value;
    const property = this.propertyValueFilters.find((property) => property.value === propertyId);

    if (property && (property.label === 'Account ID' || property.label === 'MPOP Account')) {
      result = true;
    }

    return result;
  }

  clearValues(rule: AbstractControl) {
    let value: any = '';
    let operator: string = '';

    if (this.isFilterSelected(rule, 'Make') || this.isAccountIdFilterSelected(rule)) {
      value = [];
    }

    if (this.isFilterSelected(rule, 'New/Used')) {
      operator = 'is';
    }

    rule.get('selectedOperator').setValue(operator);
    rule.get('value').setValue(value);
  }

  /**
   * Automatically set the operator based on the number of selected items in a dropdown or multi-select input
   */
  handleValueDropdownChange(rule: AbstractControl) {
    const makes = rule.get('value')?.value;
    let value = 'is';

    if (Array.isArray(makes) && makes.length > 1) {
        value = 'in';
    }

    rule.get('selectedOperator').setValue(value);
  }

  /**
   * Set the operator to "is" for New/Used filter
   */
  setNewUsedOperator(rule: AbstractControl) {
    rule.get('selectedOperator').setValue('is');
  }

}
